import { render, staticRenderFns } from "./TransactionPending.vue?vue&type=template&id=935fc71c&scoped=true"
import script from "./TransactionPending.vue?vue&type=script&lang=js"
export * from "./TransactionPending.vue?vue&type=script&lang=js"
import style0 from "./TransactionPending.vue?vue&type=style&index=0&id=935fc71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935fc71c",
  null
  
)

export default component.exports